import React from "react";

const TweetButton = ({ url }) => {
  return (
    <a
      href={`https://twitter.com/intent/tweet?url=${url}&text=`}
      target="_blank"
      className="group flex h-10 w-[122px] items-center justify-center rounded-xl bg-tracer-gray font-semibold transition-colors duration-500 hover:bg-blue-600 hover:text-white"
    >
      <svg
        width="16"
        height="13"
        viewBox="0 0 16 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Tweet"
        className="mr-3.5 h-4 w-4"
      >
        <path
          d="M13.9473 3.18433C14.5332 2.74487 15.0605 2.21753 15.4707 1.60229C14.9434 1.83667 14.3281 2.01245 13.7129 2.07104C14.3574 1.69019 14.8262 1.10425 15.0605 0.371826C14.4746 0.723389 13.8008 0.987061 13.127 1.13354C12.541 0.518311 11.75 0.166748 10.8711 0.166748C9.17187 0.166748 7.79492 1.5437 7.79492 3.24292C7.79492 3.47729 7.82422 3.71167 7.88281 3.94604C5.33398 3.79956 3.04883 2.56909 1.52539 0.723389C1.26172 1.16284 1.11523 1.69019 1.11523 2.27612C1.11523 3.33081 1.64258 4.26831 2.49219 4.82495C1.99414 4.79565 1.49609 4.67847 1.08594 4.44409V4.47339C1.08594 5.96753 2.14062 7.198 3.54687 7.49097C3.3125 7.54956 3.01953 7.60815 2.75586 7.60815C2.55078 7.60815 2.375 7.57886 2.16992 7.54956C2.55078 8.78003 3.69336 9.65894 5.04102 9.68823C3.98633 10.5085 2.66797 11.0066 1.23242 11.0066C0.96875 11.0066 0.734375 10.9773 0.5 10.948C1.84766 11.8269 3.45898 12.325 5.2168 12.325C10.8711 12.325 13.9473 7.66675 13.9473 3.59448C13.9473 3.448 13.9473 3.33081 13.9473 3.18433Z"
          className="fill-[#374151] transition-colors duration-500 group-hover:fill-white"
        />
      </svg>
      Tweet
    </a>
  );
};

export default TweetButton;
